// @ts-nocheck
import { Plugin } from '/workspace/mars-web/node_modules/.pnpm/@umijs+runtime@3.5.43_react@17.0.2/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request','qiankun',],
});

export { plugin };
